import useScrollListener from "../../hooks/useScrollListener";


import Footer from "../footer/footer.component";

import { 
	AboutRouteContainer, 
	AboutContainer
 } from "./about.styles";


const About = ({ onScroll }) => {
	const contentRef = useScrollListener(onScroll);

	return (
		<AboutRouteContainer  ref={contentRef}>
				<AboutContainer theme={{ hoverBg: 'white', hoverBrd: 'black' }}>
					<div className='about-info' >
						<h2>ABOUT US</h2>
						<p>Welcome to Tree!</p>
						<p>We're not just another ecommerce development and marketing company.</p>
						<p>At Tree, we believe in helping brands grow and thrive online, just like a tree naturally reaches for the sun.</p>
						<p>Whether you're just starting out or looking to scale, we're here to nurture your ideas and turn them into thriving online stores.</p>
						<p>We love what we do, and that shows in how we work with you—no jargon, no fuss, just real, down-to-earth support to help you succeed.</p>
						<p>Our goal? To make sure your business not only stands tall but also grows strong in the digital world.</p>
						<p>Let’s grow together! 🌱</p>
						{/* <Button text="CONTACT US" loc="/company/contactus" /> */}
						
					</div>
					<div class="klaviyo-form-RaLuFy"></div>
					<Footer />
				</AboutContainer>
		</AboutRouteContainer>
	)
}

export default About;